$("flowbox-video[autoplay]").each(function(){ this.play(); })  
  
$(document).scroll(function(){

    // let container = $('#kn-content-section-6');
    // let elementParallax = $('#flowbox-parallax');
    // let globalDistance = $(window).scrollTop();
    // let elementDistance = container.offset().top;
    // let elementViewportDistance = (elementDistance - globalDistance);

    // /*let containerNextSection = $('#kn-content-section-7');
    // let nextElementDistance = containerNextSection.offset().top;
    // let nextElementViewportDistance = (nextElementDistance - globalDistance);*/

    // let containerVideo = $('#flowbox-video');
    // let videoDistance = containerVideo.offset().top;
    // let videoViewportDistance = (videoDistance - globalDistance);

    // let videoContainer = $('#flowbox-video');

    // //console.log("elementDistance "+elementViewportDistance);

    // if(elementViewportDistance <= 0){
    //     elementParallax.addClass('parallax-fixed');
    //     //console.log("next "+nextElementViewportDistance);
    //     //console.log("video "+videoViewportDistance);
    //     videoContainer.css("margin-top", "200px");

    //     /*if(nextElementViewportDistance <= 330){
    //         elementParallax.css("top", (nextElementViewportDistance-180)+"px");
    //     }else{
    //         elementParallax.css("top", "160px");
    //     }*/
    //     if(videoViewportDistance <= 30){
    //         elementParallax.css("top", (videoViewportDistance-180)+"px");
    //     }else{
    //         elementParallax.css("top", "5rem");
    //     }
    // }else{
    //     elementParallax.removeClass('parallax-fixed');
    //     videoContainer.css("margin-top", "0px");
    // }

});